/**
 * Assigns or executes a ref.
 * @private
 * @param vnode
 */
const getRef = vnode => {
	const ref = vnode.data.ref; // eslint-disable-line prefer-destructuring

	if (ref && typeof ref === 'function') ref(vnode.elm);
	else if (ref && typeof ref === 'object') ref.current = vnode.elm;
};

export default {
	create: (oldVnode, vnode) => getRef(vnode),
	update: (oldVnode, vnode) => getRef(vnode),
	destroy: vnode => getRef(vnode)
};
